import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronLeftIcon, ChevronRightIcon, MapPinIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
interface Testimonial {
  quote: string;
  name: string;
  location: string;
  role: string;
  image: string;
}
const testimonials: Testimonial[] = [{
  quote: 'Organicé todo el año en una tarde. Ahora tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.',
  name: 'Sofía M.',
  location: 'Buenos Aires',
  role: 'Profe de Stretching en Estudio Propio',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/1ac64876-b8e0-4ff8-b2d7-2402614456a3.jpg'
}, {
  quote: 'Las clases con progresión real por nivel cambiaron todo. Mis alumnas mejoraron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'Profe de Stretching en Centro de Adultos Mayores',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d0dfb67d-e766-4580-9d5a-88b718b2d280.jpg'
}, {
  quote: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo.',
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Profe de Stretching Grupal e Individual',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/2a6b2bd8-db9d-4155-ba01-da6fdc88897b.jpg'
}];
export function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = testimonials[activeIndex];
  const goTo = (index: number) => setActiveIndex((index + testimonials.length) % testimonials.length);
  return <Section className="bg-brand-light !py-8 md:!py-12" data-id="element-329" data-mp="v4enkswpy9wu">
      <div className="max-w-3xl mx-auto" data-id="element-330" data-mp="1ivk4lbeeb88q">
        <div className="flex items-center justify-between mb-4" data-id="element-331" data-mp="1iuihu9o0oxb6">
          <div data-id="element-332" data-mp="1nmk1whrffsbr">
            <p className="text-brand-accent text-xs font-bold tracking-[0.16em] mb-1" data-id="element-333" data-mp="1nn24rx8lh4sn">VALIDADO POR PROFES</p>
            <h2 className="text-xl md:text-3xl font-display font-black text-white" data-id="element-334" data-mp="1xgplhfziqya6">Lo que cambia cuando tenés un sistema</h2>
          </div>
          <div className="hidden sm:flex gap-2" data-id="element-335" data-mp="1sh37v5fs3g0u">
            <button onClick={() => goTo(activeIndex - 1)} aria-label="Testimonio anterior" className="w-9 h-9 rounded-full border border-white/15 text-white flex items-center justify-center hover:bg-brand-accent hover:text-brand-dark hover:border-brand-accent transition-colors" data-id="element-336" data-mp="1og9l4fe2o79j"><ChevronLeftIcon className="w-4 h-4" data-id="element-337" data-mp="19soh8j9di40k" /></button>
            <button onClick={() => goTo(activeIndex + 1)} aria-label="Siguiente testimonio" className="w-9 h-9 rounded-full border border-white/15 text-white flex items-center justify-center hover:bg-brand-accent hover:text-brand-dark hover:border-brand-accent transition-colors" data-id="element-338" data-mp="19r3lwrf8ih1n"><ChevronRightIcon className="w-4 h-4" data-id="element-339" data-mp="vrlstzuwohmh" /></button>
          </div>
        </div>

        <div className="relative min-h-[245px] md:min-h-[205px] rounded-2xl border border-brand-accent/20 bg-[#082932] p-5 md:p-7 overflow-hidden shadow-xl" data-id="element-340" data-mp="qtailo0p853q">
          <div className="absolute -right-8 -top-12 w-40 h-40 bg-brand-accent/10 rounded-full blur-3xl" data-id="element-341" data-mp="32j9zkp8x7qki" />
          <AnimatePresence mode="wait" data-id="element-342" data-mp="37htkcmbs2wba">
            <motion.article key={active.name} initial={{
            opacity: 0,
            x: 18
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -18
          }} transition={{
            duration: 0.25
          }} className="relative z-10" data-id="element-343" data-mp="3cg4xb5xddmxq">
              <div className="flex text-amber-400 mb-4" data-id="element-344" data-mp="2ooptf8py2xkd">
                {[...Array(5)].map((_, index) => <StarIcon key={index} className="w-4 h-4 fill-current" data-id="element-345" data-mp="2sqktyb01x6x3" data-mpi={index} />)}
              </div>
              <QuoteIcon className="absolute -top-1 right-0 w-10 h-10 text-brand-accent/20" data-id="element-346" data-mp="2xickwmn4denr" />
              <p className="text-gray-100 text-base md:text-lg italic leading-relaxed pr-2" data-id="element-347" data-mp="2106l4t6waksa">“{active.quote}”</p>
              <div className="flex items-center gap-3 mt-5" data-id="element-348" data-mp="250qfjp033aaq">
                <img src={active.image} alt={`Foto de ${active.name}`} className="w-11 h-11 rounded-full object-cover border border-brand-accent/50" data-id="element-349" data-mp="24z5ls1llfvdx" />
                <div data-id="element-350" data-mp="1gyv5zepbiz95">
                  <div className="font-bold text-white text-sm" data-id="element-351" data-mp="1gzn2qsunj310">{active.name}</div>
                  <div className="flex items-center text-brand-accent text-xs mt-0.5" data-id="element-352" data-mp="1vnhvg98nt7e3"><MapPinIcon className="w-3 h-3 mr-1" data-id="element-353" data-mp="1qvgdc6ot8mg5" />{active.location} · {active.role}</div>
                </div>
              </div>
            </motion.article>
          </AnimatePresence>
        </div>

        <div className="flex items-center justify-center gap-3 mt-4" data-id="element-354" data-mp="1zotgs2ki36gh">
          <button onClick={() => goTo(activeIndex - 1)} aria-label="Testimonio anterior" className="sm:hidden w-8 h-8 rounded-full border border-white/15 text-white flex items-center justify-center" data-id="element-355" data-mp="2elkf08ifuc4i"><ChevronLeftIcon className="w-4 h-4" data-id="element-356" data-mp="29kmys1gzns5n" /></button>
          {testimonials.map((testimonial, index) => <button key={testimonial.name} onClick={() => setActiveIndex(index)} aria-label={`Ver testimonio de ${testimonial.name}`} className={`h-2 rounded-full transition-all ${index === activeIndex ? 'w-7 bg-brand-accent' : 'w-2 bg-white/25 hover:bg-white/50'}`} data-id="element-357" data-mp="f8gd28qgxsz3" data-mpi={index} />)}
          <button onClick={() => goTo(activeIndex + 1)} aria-label="Siguiente testimonio" className="sm:hidden w-8 h-8 rounded-full border border-white/15 text-white flex items-center justify-center" data-id="element-358" data-mp="2vwzcv1hzma40"><ChevronRightIcon className="w-4 h-4" data-id="element-359" data-mp="2m38wykzxf7zx" /></button>
        </div>
      </div>
    </Section>;
}